import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { 
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { REDUX, STORAGE_KEYS } from '../constants';
import authReducer from './slices/authSlice';

const persistConfig = {
  key: STORAGE_KEYS.PERSIST_ROOT,
  storage,
  whitelist: [REDUX.AUTH_SLICE]
};

const rootReducer = combineReducers({
  [REDUX.AUTH_SLICE]: authReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);